/// <reference types="@types/google.maps" />
import {inject, Injectable, NgZone} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {

  readonly #ngZone = inject(NgZone);

  initAutocomplete(addressElement: HTMLInputElement, addressForm: FormGroup): void {
    const autocomplete = new google.maps.places.Autocomplete(addressElement, {
      types: ['address'],
      componentRestrictions: {country: 'fr'} // Restrict results to France
    });

    autocomplete.addListener('place_changed', () => {
      this.#ngZone.run(() => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();

        if (!place.geometry || !place.address_components) {
          return;
        }

        const address = this.parseAddressComponents(place.address_components);

        addressForm.controls['street'].setValue(address.street);
        addressForm.controls['zipCode'].setValue(address.zipCode);
        addressForm.controls['city'].setValue(address.city);
        addressForm.controls['country'].setValue(address.country);

        if (address.country !== 'France') {
          addressForm.setErrors({notFrance: true});
        } else {
          addressForm.setErrors(null);
        }
      });
    });
  }

  private parseAddressComponents(components: google.maps.GeocoderAddressComponent[]): any {
    const address: any = {
      street: '',
      zipCode: '',
      city: '',
      country: ''
    };

    for (const component of components) {
      const componentType = component.types[0];
      switch (componentType) {
        case 'street_number':
          address.street = `${component.long_name} ${address.street}`;
          break;
        case 'route':
          address.street += component.long_name;
          break;
        case 'postal_code':
          address.zipCode = component.long_name;
          break;
        case 'locality':
          address.city = component.long_name;
          break;
        case 'country':
          address.country = component.long_name;
          break;
      }
    }

    return address;
  }
}
